import type { BuilderContent } from 'app/utils/builder'

export function isBuilderContentEmpty(content: BuilderContent | null | undefined): boolean {
  if (content == null) {
    return true
  }

  const blocks = content.data?.blocks
  if (!Array.isArray(blocks) || blocks.length === 0) {
    return true
  }

  return false
}
